export default __webpack_public_path__ + "static/media/205.2ec34701.png";